import React from "react";
const StockEditManufacturingScreen = () => {
  return (
    <div className="mt-8 text-center text-slate-500">
      StockEditManufacturingScreen
    </div>
  );
};

export default StockEditManufacturingScreen;
